module.exports = "<div class=\"chart-container\">\n  <canvas baseChart\n    [data]=\"data\"\n    [labels]=\"labels\"\n    [chartType]=\"pieChartType\"\n    [options]=\"options\"\n    [legend]=\"lineChartLegend\"\n    (chartHover)=\"chartHovered($event)\"\n    (chartClick)=\"chartClicked($event)\">\n  </canvas>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src692328540/src/src/app/common/dynamic-chart/dynamic-chart.component.html
// module id = ../../../../../src/app/common/dynamic-chart/dynamic-chart.component.html
// module chunks = main